import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { Container } from "../components/Container";
import { SEO } from "../components/SEO";
import { TrySoroBlog } from "../components/TrySoroBlog";

export function Blog() {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  return (
    <main className="pt-28 sm:pt-32">
      <SEO
        title={t("blog.meta_title")}
        description={t("blog.meta_description")}
        path="/blog"
      />

      <Container size="xl">
        <article className="py-12 sm:py-16">
          <header className="max-w-3xl">
            <p className="mb-3 text-sm font-semibold uppercase tracking-[0.25em] text-brand-500">
              {t("blog.eyebrow")}
            </p>
            <h1 className="hero-headline text-text-heading">{t("blog.title")}</h1>
            <p className="mt-4 text-lg text-text-muted">{t("blog.subtitle")}</p>
          </header>

          <TrySoroBlog />
        </article>
      </Container>
    </main>
  );
}
